// eslint-disable-next-line no-unused-vars
import React from "react"
import Img from "gatsby-image"
/** @jsx jsx */
import { jsx } from "theme-ui"
import TestimonyCardContent from "./testimony-card-content"

const TestimonyCard = ({ fixedImg, name, position, paragraph }) => {
  return (
    <>
      <div
        sx={{
          minHeight: "19rem",
          py: "3.9065rem",
          mt: "3.9065rem",
          borderRadius: "20px",
          border: "solid 1px #e3e3e3",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: [`100%`, `100%`, `30rem`, `30rem`],
        }}
      >
        <div
          sx={{
            position: "relative",
            top: "-7.813rem",
            height: 0,
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Img alt="" style={{ borderRadius: 99999 }} fixed={fixedImg} />
        </div>
        <TestimonyCardContent
          name={name}
          position={position}
          paragraph={paragraph}
        />
      </div>
    </>
  )
}

export default TestimonyCard
